module.exports = __webpack_public_path__ + "img/singletrack-refresh-thumbnail.7cca66f5.png";